import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  CATALOG,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchCatalogs = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  const available = 'isAvailable.EQ=true';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG}?${payload.filterParams}&${available}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG}${query}${sorting}&${payload.filterParams}&${available}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG}${query}${sorting}&${available}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG}${query}${sorting}&${available}`);
};

const postCatalog = async (params) => axiosAuthInstance.post(API_END_POINTS.GET_CATALOAG_ORDER, params);

export function* getCatalogs(action) {
  try {
    const { data: { entity } } = yield call(fetchCatalogs, action.payload);
    yield put({ type: CATALOG.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: CATALOG.FAILED, payload: e.response.data });
  }
}

export function* orderCatalog(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postCatalog, action.payload);
    const { data: { entity } } = yield call(fetchCatalogs, action.payload);
    yield put({ type: CATALOG.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Your order placed successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
